
document.getElementById("shop-button").addEventListener("click", handleShopMenu);
document.getElementById("why-nordic-button").addEventListener("click", handleShopMenu);
document.getElementById("learn-button").addEventListener("click", handleShopMenu);

function handleShopMenu(e) {
    // console.log(e)
    const dropdown = e.target.nextSibling.nextSibling;
    const dropdownContainer = dropdown.childNodes[1];
    const allDropDowns = document.querySelectorAll('.navigation__dropdown-container')

    allDropDowns.forEach(function(singleDropdown) {
        singleDropdown.classList.remove('active');
        singleDropdown.style.height = '0px';
    });

    dropdown.classList.toggle('active');
    console.log('dropdownContainer.height', dropdown.height )

    if(dropdown.getBoundingClientRect().height === 0){
        dropdown.style.height = ''+ dropdownContainer.clientHeight +'px';
    } else {
        dropdown.style.height = '0px'
    }    
}